import { Component, EventEmitter, NgZone, OnDestroy, OnInit, Output } from '@angular/core';

// 以下追加したもの
import { AuthService } from '@app/services/auth.service';
import { Define } from '@app/models/define';
import { Firestore } from '@angular/fire/firestore';
import { Analytics, setUserProperties } from '@angular/fire/analytics';
import packageJson from '../../../../package.json';
import { ActivatedRoute, Router } from '@angular/router';
import { collection, onSnapshot, query, Unsubscribe, where } from 'firebase/firestore';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.css']
})
export class UserInfoComponent implements OnInit, OnDestroy {
  requestCount: number;
  changeReqUnsubscribe?: Unsubscribe;
  public appVersion: string = packageJson.version;
  @Output() menuClicked = new EventEmitter();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public auth: AuthService,
    private firestore: Firestore,
    private analytics: Analytics,
    private ngZone: NgZone) { }

  ngOnInit() {
    this.requestCount = 0;
    this.auth.user.subscribe( async user => {

      if (user) {
        // GAのカスタムディメンションを設定
        setUserProperties(this.analytics, { 'dimension1': Define.ManageAuthorityName.find(elm => elm.id === user.manageAuthority).value });
        setUserProperties(this.analytics, { 'dimension2': Define.AuthorityName.find(elm => elm.id === user.authority).value });
        setUserProperties(this.analytics, { 'dimension3': this.appVersion });
        if (user.authority >= Define.Authority.Approver) {
          this.changeReqUnsubscribe = onSnapshot(
            query(
              collection(this.firestore, 'change-request'),
              where('approverUid', '==', user.uid),
              where('state', '==', Define.RequestState.Registered),
              where('dataVersion', '>=', 1)
            ),
            snapshot => this.ngZone.run(() => this.requestCount = snapshot.size)
          );
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.changeReqUnsubscribe?.();
  }

  async logout() {
    // 親にページ遷移を通知
    this.menuClicked.emit();
    await this.auth.logout();
    this.changeReqUnsubscribe?.();
  }

  async rootPage(url: string) {
    // 親にページ遷移を通知
    this.menuClicked.emit();
    this.router.navigate([url], {relativeTo: this.route });
  }

}
